import { SubRange } from '../../../engine'
import { anim, prog, stagger } from '../../../motion'
import { Phone, Shape } from '../../../primitives'
import { GAME_TEXT, GameScreens } from '../../../scenes/SceneGames'
import { Fit, Line } from '../../../v2/kit'
import { useCopy, useLang } from '../../i18n'

const GAME_SHAPES = [
  ['sq', 'green'],
  ['dot', 'pink'],
  ['tri', 'yellow']
]
const STRENGTH_SHAPES = [
  ['dot', 'pink'],
  ['tri', 'yellow'],
  ['sq', 'green']
]
const CAPTIONS = [
  { side: 'left', at: [0.24, 0.29], out: [0.39, 0.43] },
  { side: 'right', at: [0.44, 0.49], out: [0.58, 0.62] },
  { side: 'left', at: [0.63, 0.68], out: [0.78, 0.82] },
  { side: 'right', at: [0.84, 0.89] }
]
const NARROW = { maxW: 0.7, maxH: 0.56 }

// Wie Version 2: Das Smartphone richtet sich auf, dann laufen Start, Spiele und Stärkenprofil
export default function DemoTesting() {
  const c = useCopy('testung')
  const lang = useLang()

  return (
    <div className='cin-full'>
      <div
        className='cin-split cin-split--left'
        style={anim({
          at: [0.03, 0.12],
          out: [0.18, 0.23],
          x: -80,
          y: 0,
          ox: -80,
          oy: 0
        })}
      >
        {c.split[0]}
      </div>
      <div
        className='cin-split cin-split--right'
        style={anim({
          at: [0.07, 0.16],
          out: [0.18, 0.23],
          x: 80,
          y: 0,
          ox: 80,
          oy: 0
        })}
      >
        {c.split[1]}
      </div>

      {CAPTIONS.map((pos, i) => (
        <div
          key={i}
          className={`cin-caption cin-caption--${pos.side}`}
          style={anim({ at: pos.at, out: pos.out, y: 40, oy: -40 })}
        >
          <div className='cin-eyebrow cin-eyebrow--light'>
            {c.captions[i].eyebrow}
          </div>
          <div className='cin-caption__text'>{c.captions[i].text}</div>
        </div>
      ))}

      <Line at={[0.9, 0.96]} y={20} className='dm-library'>
        {c.library}
      </Line>

      <Fit
        w={260}
        h={540}
        maxH={0.8}
        maxW={0.5}
        narrow={NARROW}
        className='cin-phone-fit'
      >
        <div
          className='cin-phone-3d'
          style={{
            ...prog([0, 0.2]),
            transform:
              'translateY(calc((1 - var(--p)) * 220px)) rotateX(calc((1 - var(--p)) * 58deg)) ' +
              'rotateZ(calc((1 - var(--p)) * -24deg)) scale(calc(0.72 + 0.28 * var(--p)))'
          }}
        >
          <Phone x={0} y={0}>
            <div
              className='sty-abs sty-screen'
              style={anim({ at: [-1, 0], out: [0.2, 0.23], y: 0, oy: -20 })}
            >
              <div className='sty-h4'>{c.hello}</div>
              <div className='sty-muted sty-small sty-mt-1'>{c.intro}</div>
              <div className='sty-mt-4'>
                {c.games.map((g, i) => (
                  <div
                    key={g.title}
                    className='sty-game-row'
                    style={anim({
                      at: stagger(0.08, 0.02, 0.05, i),
                      x: 20,
                      y: 0
                    })}
                  >
                    <Shape
                      kind={GAME_SHAPES[i][0]}
                      color={GAME_SHAPES[i][1]}
                      size={18}
                    />
                    <span className='sty-grow'>{g.title}</span>
                    <span className='sty-muted sty-small'>{g.dim}</span>
                  </div>
                ))}
              </div>
              <div
                className='sty-btn sty-btn--full'
                style={anim({ at: [0.14, 0.18], s: 0.9, y: 10 })}
              >
                {c.start}
              </div>
            </div>

            <SubRange
              at={[0.23, 0.82]}
              className='sty-abs cin-inset'
              style={anim({
                at: [0.21, 0.24],
                out: [0.8, 0.83],
                y: 20,
                oy: -20
              })}
            >
              <GameScreens text={GAME_TEXT[lang]} />
            </SubRange>

            <div
              className='sty-abs sty-screen'
              style={anim({ at: [0.82, 0.86], y: 20 })}
            >
              <div className='sty-feedback-head'>
                <div className='sty-h4 sty-center'>{c.profile}</div>
              </div>
              {c.strengths.map((s, i) => (
                <div
                  key={s.title}
                  className='sty-strength'
                  style={anim({ at: stagger(0.85, 0.03, 0.06, i), y: 24 })}
                >
                  <Shape
                    kind={STRENGTH_SHAPES[i][0]}
                    color={STRENGTH_SHAPES[i][1]}
                    size={26}
                  />
                  <div>
                    <div className='sty-strong'>{s.title}</div>
                    <div className='sty-muted sty-small'>{s.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </Phone>
        </div>
      </Fit>
    </div>
  )
}
